<template>
	<div class="featured">
		<div class="items">
			<item v-for="item in items" :key="item.id" v-bind="item"/>
		</div>
	</div>
</template>

<script>
import item from "./item.vue";

export default {
	components: {item},
	computed: {
		items() {
			return this.$store.getters["news/featured"];
		}
	},
	created() {
		if(!this.items.length) {
			this.$store.dispatch("news/getFeatured");
		}
	}
};
</script>

<style lang="scss" scoped>
.featured {
	.items {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}
}
</style>
